import { useQuery } from '@tanstack/react-query';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { getChannelsAddons } from 'src/api/getChannelsAddons/getChannelsAddons';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from 'src/constants/QueryKeys';

export const useGetChannelsAddons = () => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();
  return useQuery({
    queryKey: [QueryKeys.CHANNELS_ADDONS],
    queryFn: getChannelsAddons,
    onError: (e: Error) => {
      showSnackbar({
        message: e.message,
        status: SnackbarStatus.ERROR,
      });
      captureException(e);
    },
  });
};
